<template>
  <div class="chat-view" :class="platformClass">
    <ChatContainer />
  </div>
</template>

<script setup>
import { computed } from "vue";
import ChatContainer from "@/components/chat/ChatContainer.vue";
import { useAppStore } from "@/stores/app.js";

const appStore = useAppStore();

// 计算属性
const platformClass = computed(() => appStore.platformClass);
</script>

<style lang="scss" scoped>
.chat-view {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.is-desktop {
  // 桌面端特殊样式
  max-width: 480px;
  margin: 0 auto;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
</style>
